module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m_context plr"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "id": "addForm",
      "model": _vm.form,
      "label-width": "12.5%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.label_areaid')
    }
  }, [_c('MechanismSelector', {
    attrs: {
      "data": _vm.mechanismData,
      "mselect": true,
      "classs": 'w_33'
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ter_num')
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("  " + _vm._s(_vm.form.terNums) + "  ")]), _vm._v(_vm._s(_vm.$t('terminal.appLog.tower')) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.ota_bao')
    }
  }, [_c('el-select', {
    staticClass: "w_33",
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": _vm.$t('lin_global.ple_sel_ota')
    },
    model: {
      value: (_vm.form.otaId),
      callback: function($$v) {
        _vm.$set(_vm.form, "otaId", $$v)
      },
      expression: "form.otaId"
    }
  }, _vm._l((_vm.otaList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isSubmit
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('lin_btn.lock')))])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5c8c5948"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/terminal/ota.vue
// module id = 1053
// module chunks = 0